<template>
  <el-form class="search_form" inline size="small" label-suffix=":">
    <el-form-item label="企业名">
      <el-input
        class="filter"
        placeholder="请输入企业名"
        v-model="searchForm"
        clearable
        @change="changeSearch"
      ></el-input>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" icon="el-icon-plus" @click="add"
        >新增企业</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      searchForm: "",
    };
  },
  mounted() {},
  methods: {
    changeSearch() {
      this.$emit("search-change", this.searchForm);
    },
    // 点击新增
    add() {
      //   console.log("您点击了新增账号");
      this.$emit("add-company");
    },
  },
};
</script>

<style lang="scss">
.search_form {
  display: flex;
  justify-content: end;
}
</style>


// WEBPACK FOOTER //
// src/pages/index/views/companyManage/companySearch.vue